(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const cartDrawer = document.getElementById('cart-drawer');
  const closeButton = document.getElementById('close-button');

  closeButton.addEventListener('click', (event) => {
    event.preventDefault();
    cartDrawer.open = false;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-footer"] && !Shopify.designMode) return;
  try {
    const cartDrawer = document.querySelector('#cart-drawer');
  const continueShoppingButton = cartDrawer.querySelector('[data-continue-shopping]');

  continueShoppingButton.addEventListener('click', (e) => {
    e.preventDefault();
    cartDrawer.open = false;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localisation-modal"] && !Shopify.designMode) return;
  try {
    const localisationModal = document.querySelector('.localisation-modal');
  const closeButton = document.querySelector('.localisation-modal__close-button');
  const formSubmitButton = document.querySelector('#location_submit');

  localisationModal.addEventListener('click', (e) => {
    if (e.target === localisationModal) {
      localisationModal.close();
    }
  });

  localisationModal.addEventListener('keyup', (e) => {
    if (e.code.toUpperCase() !== 'ESCAPE') return;

    localisationModal.close();
  });

  closeButton.addEventListener('click', () => {
    const localisationModal = document.querySelector('.localisation-modal');
    localisationModal.close();
  });

  formSubmitButton.addEventListener('click', () => {
    localisationModal.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-drawer"] && !Shopify.designMode) return;
  try {
    const sizeDrawer = document.getElementById('size-drawer');
  const closeButton = sizeDrawer.querySelector('#close-button');

  function openSizeDrawer(hash) {
    if (hash !== '#size-guide') {
      return;
    }

    sizeDrawer.open = true;
  }

  function resetHash() {
    // Remove hash from URL but retain search params
    const searchParams = location.search;
    const newLocation = location.pathname + searchParams;
    window.history.pushState({}, '', newLocation);
  }

  // After page load, check if the URL has a hash and open the drawer if it does
  if (location.hash === '#size-guide') {
    sizeDrawer.open = true;
  }

  // Close the drawer when the close button is clicked
  closeButton.addEventListener('click', (event) => {
    event.preventDefault();
    sizeDrawer.open = false;
  });

  // Open the drawer when the URL has a hash
  window.addEventListener('hashchange', (event) => {
    openSizeDrawer(location.hash);
  });

  // Reset the hash when the drawer is closed
  sizeDrawer.addEventListener('close', () => {
    resetHash();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text-input"] && !Shopify.designMode) return;
  try {
    const fields = document.querySelectorAll('.text-input');

  fields.forEach((field) => {
    const input = field.querySelector('.text-input__input');
    const error = field.querySelector('.text-input__error');

    const requiredMessage = input.dataset.required ?? 'This field is required.';
    const typeMessage = input.dataset.error ?? 'Please input a valid value.';

    input.addEventListener('input', (event) => {
      if (input.validity.valid) {
        error.textContent = '';
        error.className = 'text-input__error';
      } else {
        showError(input, error, requiredMessage, typeMessage);
      }
    });
  });

  function showError(inputEl, errorEl, requiredErrorMessage, typeErrorMessage) {
    if (inputEl.validity.valueMissing) {
      // If empty
      errorEl.textContent = requiredErrorMessage;
    } else if (inputEl.validity.typeMismatch) {
      // If the entered value does not match the field type
      errorEl.textContent = typeErrorMessage;
    } else if (inputEl.validity.patternMismatch) {
      // If the entered value does not match the field pattern
      errorEl.textContent = typeErrorMessage;
    }
    // Add the `active` class
    errorEl.className = 'text-input__error active';
  }
  } catch(e) { console.error(e); }
})();

})();
